import { ChangeDetectionStrategy, Component, inject, input, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomDatePickerComponent, FormToggleComponent, InfoHoverComponent, UI_FORM_IMPORTS } from '@program-suite/ui';
import { WizardStore } from '@program-suite/data-common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AuthStore } from '@program-suite/data-auth';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-coverage-adjustment-step2',
  imports: [
    CommonModule,
    ...UI_FORM_IMPORTS,
    ReactiveFormsModule,
    FormToggleComponent,
    InfoHoverComponent,
    CustomDatePickerComponent
  ],
  templateUrl: './coverage-adjustment-step2.component.html',
  styleUrl: './coverage-adjustment-step2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoverageAdjustmentStep2Component {
  form = model<FormGroup>();
  disableReQuote = input<boolean>(false);
  authStore = inject(AuthStore);
  wizardStore = inject(WizardStore);
  private router = inject(Router);
  data: any;

  constructor() {
    this.data = this.router.currentNavigation()?.extras.state || {};
  }
}
